import styles from './ConnectorCatalogCard.module.css'

/**
 * ConnectorCatalogCard — displays an available (not yet connected) connector.
 *
 * Props:
 *   icon        {string}    — filename from /public/images (e.g. "zendesk.png")
 *   name        {string}    — connector display name
 *   description {string}    — short description
 *   category    {string}    — category label (e.g. "ITSM", "CRM")
 *   connecting  {boolean}   — true while the connect request is in flight
 *   onConnect   {function}  — called when "+ Connect" is clicked
 */
export default function ConnectorCatalogCard({ icon, name, description, category, connecting, onConnect }) {
  const iconUrl = icon ? `/${icon}` : ''

  const initials = name
    .split(' ')
    .slice(0, 2)
    .map(w => w[0]?.toUpperCase() ?? '')
    .join('')

  return (
    <div className={styles.card}>

      {/* ── Icon ── */}
      <div className={styles.iconWrap}>
        {iconUrl ? (
          <img
            src={iconUrl}
            alt={name}
            className={styles.iconImg}
            onError={e => {
              e.currentTarget.style.display = 'none'
              e.currentTarget.parentElement.dataset.fallback = initials
            }}
          />
        ) : (
          <span>{initials}</span>
        )}
      </div>

      {/* ── Name ── */}
      <p className={styles.name}>{name}</p>

      {/* ── Category pill ── */}
      <span className={styles.categoryPill}>{category}</span>

      {/* ── Description ── */}
      <p className={styles.description}>{description}</p>

      {/* ── Connect button ── */}
      <button
        className={styles.connectBtn}
        onClick={onConnect}
        disabled={connecting}
        aria-label={`Connect ${name}`}
      >
        {connecting ? 'Connecting…' : '+ Connect'}
      </button>

    </div>
  )
}

// ---------------------------------------------------------------------------
// (no avatar color helper needed — background is white)
// ---------------------------------------------------------------------------
